<template>
  <div class="nav-wrapper">
    <div class="experience-container">
      <div class="form-section">
        <div class="business-form">
          <BackButton @back="$emit('back')" />
          <h1 class="main-title">{{ $t("einDocuments.title") }}</h1>
          <p class="subtitle">{{ $t("einDocuments.subtitle") }}</p>
          <p class="subtitle">{{ $t("einDocuments.subtitle2") }}</p>

          <div class="documents-card">
            <h3 class="whatToKnow">{{ $t("einDocuments.whatToKnow") }}</h3>
            <ul class="benefits-list">
              <li>
                <div class="check-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 6L9 17L4 12"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>{{ $t("einDocuments.benefits.bundle") }}</span>
              </li>
              <li>
                <div class="check-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 6L9 17L4 12"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>{{ $t("einDocuments.benefits.charge") }}</span>
              </li>
            </ul>

            <div class="documents-options">
              <label class="document-option">
                <input
                  type="radio"
                  v-model="selectedDocuments"
                  value="bundle"
                  class="radio-input"
                />
                <div class="option-content">
                  <span class="radio-custom"></span>
                  <div class="option-details">
                    <span class="option-text">{{
                      $t("einDocuments.options.bundle.text")
                    }}</span>
                    <span class="option-price">{{
                      $t("einDocuments.options.bundle.price")
                    }}</span>
                  </div>
                </div>
              </label>

              <label class="document-option">
                <input
                  type="radio"
                  v-model="selectedDocuments"
                  value="ein"
                  class="radio-input"
                />
                <div class="option-content">
                  <span class="radio-custom"></span>
                  <div class="option-details">
                    <span class="option-text">{{
                      $t("einDocuments.options.ein.text")
                    }}</span>
                    <span class="option-price">{{
                      $t("einDocuments.options.ein.price")
                    }}</span>
                  </div>
                </div>
              </label>

              <label class="document-option">
                <input
                  type="radio"
                  v-model="selectedDocuments"
                  value="documents"
                  class="radio-input"
                />
                <div class="option-content">
                  <span class="radio-custom"></span>
                  <div class="option-details">
                    <span class="option-text">{{
                      $t("einDocuments.options.documents.text")
                    }}</span>
                    <span class="option-price">{{
                      $t("einDocuments.options.documents.price")
                    }}</span>
                  </div>
                </div>
              </label>

              <label class="document-option">
                <input
                  type="radio"
                  v-model="selectedDocuments"
                  value="none"
                  class="radio-input"
                />
                <div class="option-content">
                  <span class="radio-custom"></span>
                  <span class="option-text">{{
                    $t("einDocuments.options.none")
                  }}</span>
                </div>
              </label>
            </div>

            <p class="note">{{ $t("einDocuments.note") }}</p>

            <button class="next-button" @click="handleNext">
              {{ $t("einDocuments.next") }}
            </button>
          </div>
        </div>
      </div>

      <div class="info-section">
        <div class="info-content">
          <h2 class="info-title">{{ $t("einDocuments.infoTitle") }}</h2>
          <p class="info-text">
            {{ $t("einDocuments.titleDescription") }}
          </p>
          <div class="video-container">
            <iframe
              src="https://www.youtube.com/embed/3lLCWiW0iBQ"
              title="Registered Agent Video"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              class="video-iframe"
            ></iframe>
          </div>

          <h3 class="info-subtitle">
            {{ $t("einDocuments.documentsTitle") }}
          </h3>
          <p class="info-text">
            {{ $t("einDocuments.documentsDescription") }}
          </p>

          <div class="illustration-container">
            <img
              src="@/assets/documents-illustration.png"
              alt="Documents Illustration"
              class="business-illustration"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackButton from "./BackButton.vue";

export default {
  name: "EinDocuments",
  components: {
    BackButton,
  },
  data() {
    return {
      selectedDocuments: "bundle",
    };
  },
  methods: {
    handleNext() {
      this.$emit("next", {
        selectedDocuments: this.selectedDocuments,
      });
    },
  },
};
</script>

<style scoped>
@import "@/styles/CustomerBusiness.css";
</style>
